var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlowchart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.087 0H9.913a2.612 2.612 0 00-2.609 2.609v4.174a2.612 2.612 0 002.61 2.608h4.173a2.612 2.612 0 002.609-2.608V2.609A2.612 2.612 0 0014.087 0z",
    fill: "#2F54EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.643 18.783H20.14c-.748 0-1.356.608-1.356 1.356v2.504c0 .749.608 1.357 1.356 1.357h2.504c.749 0 1.357-.608 1.357-1.357V20.14c0-.748-.608-1.356-1.357-1.356zM3.86 18.783H1.358C.608 18.783 0 19.39 0 20.139v2.504C0 23.392.608 24 1.357 24H3.86c.748 0 1.356-.608 1.356-1.357V20.14c0-.748-.608-1.356-1.356-1.356z",
    fill: "#597EF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.26 13.565h-5.738v-2.608a.522.522 0 00-1.044 0v2.608H5.74a3.656 3.656 0 00-3.652 3.652.522.522 0 001.043 0 2.612 2.612 0 012.61-2.608h12.52a2.612 2.612 0 012.61 2.608.522.522 0 001.043 0 3.656 3.656 0 00-3.652-3.652z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/flowchart.7ad68f72d467850edbf748261ff4a630.svg";
export { SvgFlowchart as ReactComponent };